import { createStyles, rem } from '@mantine/core'

export default createStyles((theme) => {
  return {
    root: {},
    body: {
      padding: 16,
      [theme.fn.largerThan('sm')]: {
        padding: `${rem(24)} ${rem(24)} ${rem(24)} ${rem(48)}`,
      },
    },
    modalBody: {
      padding: 0,
    },
    disclaimer: {
      justifyContent: 'center',
    },
  }
})
